var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "room-doc-share-component",
      attrs: { "data-grm-comp": "Share" },
    },
    [
      _c(
        "div",
        { staticClass: "room-doc-share" },
        [
          _vm.me.roomUserRole.draw
            ? _c(
                "div",
                {
                  staticClass: "room-doc-share-start",
                  class: { isOpen: _vm.isOpenDocFileList },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "room-doc-share-list-wrapper",
                      class: { page: _vm.isShowDocPage },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "room-doc-share-list-container" },
                        [
                          _c(
                            "div",
                            { staticClass: "room-doc-share-start-header" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "room-doc-share-start-header-title-wrapper",
                                },
                                [
                                  _c(
                                    "p",
                                    {
                                      staticClass:
                                        "room-doc-share-start-header-title",
                                    },
                                    [_vm._v(_vm._s(_vm.$t("doc.share.title")))]
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _c(
                            "perfect-scrollbar",
                            { staticClass: "min-h-0 flex-1" },
                            [
                              _c(
                                "div",
                                { staticClass: "room-doc-share-start-body" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "room-doc-share-file-list-wrapper",
                                    },
                                    [
                                      _c("RoomDocList", {
                                        on: {
                                          onToggleShowDocPage:
                                            _vm.onToggleShowDocPage,
                                          setShowDocPage: _vm.setShowDocPage,
                                        },
                                      }),
                                      _c(
                                        "ul",
                                        {
                                          staticClass:
                                            "room-doc-share-file-list",
                                        },
                                        [
                                          _c(
                                            "li",
                                            {
                                              staticClass:
                                                "room-doc-share-file-item add file",
                                              on: {
                                                click: _vm.handleClickAddDoc,
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "room-doc-share-file",
                                                },
                                                [
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass:
                                                        "room-doc-share-add-label",
                                                      attrs: { for: "file" },
                                                    },
                                                    [
                                                      _c("input", {
                                                        staticClass:
                                                          "room-doc-share-add-input",
                                                        attrs: {
                                                          type: "file",
                                                          id: "file",
                                                        },
                                                      }),
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "doc.share.add.file"
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "li",
                                            {
                                              staticClass:
                                                "room-doc-share-file-item add link",
                                              on: { click: _vm.onClickAddLink },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "room-doc-share-file",
                                                },
                                                [
                                                  _c(
                                                    "p",
                                                    {
                                                      staticClass:
                                                        "room-doc-share-add-label",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "doc.share.add.link"
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "room-doc-share-list-container page" },
                        [
                          _c(
                            "div",
                            { staticClass: "room-doc-share-start-header" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "room-doc-share-start-header-title-wrapper",
                                },
                                [
                                  _c(
                                    "button",
                                    {
                                      staticClass:
                                        "room-doc-share-start-header-title back",
                                      on: { click: _vm.onToggleShowDocPage },
                                    },
                                    [_vm._v(_vm._s(_vm.$t("doc.share.list")))]
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _c(
                            "perfect-scrollbar",
                            {
                              ref: "docListDetailScrollbar",
                              staticClass: "min-h-0 flex-1",
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "room-doc-share-start-body" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "room-doc-share-file-list-wrapper",
                                    },
                                    [
                                      _vm.isShowDocPage
                                        ? _c("RoomDocListDetail")
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                  _c("GrmSlideToggleBtn", {
                    directives: [
                      {
                        name: "tooltip",
                        rawName: "v-tooltip.right",
                        value: _vm.isOpenDocFileList
                          ? _vm.$t("doc.share.close")
                          : _vm.$t("doc.share.open"),
                        expression:
                          "isOpenDocFileList ? $t('doc.share.close') : $t('doc.share.open')",
                        modifiers: { right: true },
                      },
                    ],
                    staticClass: "absolute transform transition-none",
                    class: [
                      _vm.isOpenDocFileList
                        ? "translate-x-1/2"
                        : "translate-x-full",
                    ],
                    attrs: { direction: "left" },
                    on: { click: _vm.onToggleDocFileList },
                    model: {
                      value: _vm.isOpenDocFileList,
                      callback: function ($$v) {
                        _vm.isOpenDocFileList = $$v
                      },
                      expression: "isOpenDocFileList",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _c(
            "div",
            { staticClass: "room-doc-share-center" },
            [
              _c("RoomDocView", {
                ref: "csCanvas",
                attrs: { roomGroupId: "default" },
              }),
              _vm.getCurrentRoomDocFile &&
              _vm.getCurrentRoomDocFile.pages &&
              _vm.getCurrentRoomDocFile.pages.length > 1
                ? _c("RoomDocPaging", {
                    staticClass: "absolute top-2",
                    on: { paging: () => (this.isShowDocPage = true) },
                  })
                : _vm._e(),
              !_vm.me.roomUserRole.draw
                ? _c("RoomDocZoom", { staticClass: "absolute top-2 right-2" })
                : _vm._e(),
            ],
            1
          ),
          _vm.me.roomUserRole.draw
            ? _c(
                "div",
                { staticClass: "room-doc-share-end" },
                [_c("RoomDocPalette", { ref: "palette" })],
                1
              )
            : _vm._e(),
          _c("ProgressList"),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }